import PayGoods from './PayGoods'
import store from '@/store/store.js'
import router from '@/router/router.js'

const obj = {}

obj.install = function(Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(PayGoods)

    //2.用new 的方式用组件构造器创建出来组件对象
    const buyGoodsDialog = new Construct({ router, store })

    //3.将组件对象手动挂载到某一个元素上
    buyGoodsDialog.$mount(document.createElement('div'))

    //4.upperTip.$el对应的就是div
    document.body.appendChild(buyGoodsDialog.$el)

    //5.在原型中加入UpperTip
    Vue.prototype.$PayGoods = buyGoodsDialog
}

export default obj
